import { ISearchFlight } from "@/shared/api/aviabooking"
import { FC } from "react"
import { useNavigate } from "react-router-dom"

interface BuyTicketButtonProps {
    flight: ISearchFlight
    disabled?: boolean
}

export const BuyTicketButton: FC<BuyTicketButtonProps> = ({ flight, disabled = false }) => {
    const navigate = useNavigate()
    return (
        <button type="button" disabled={disabled} onClick={() => {
            if (!disabled) navigate(`/avia-booking/flights/${flight.id}/book`)
        }} className="bg-color-primary text-white border-none rounded-2xl p-3 w-full text-center uppercase font-bold disabled:opacity-50 disabled:cursor-not-allowed">
            Купить
        </button>
    )
}